module.exports = __webpack_public_path__ + "img/ps4-controller-selected.0d046cec.png";